import { createSelector } from '@reduxjs/toolkit';

import { projectSelector } from 'src/selectors/project';

export const projectVirtualGraphSelector = (
  projectId: string,
  virtualGraphId: string | undefined
) =>
  createSelector(
    projectSelector(projectId),
    (project) =>
      (virtualGraphId && project?.virtualGraphsById[virtualGraphId]) || null
  );
